import { apiClient } from './apiService';
import {
  CUSTOMER_INVOICE_PROFILES,
  CUSTOMER_INVOICE_PROFILE_DETAIL
} from './endpoints';
import {
  CustomerInvoiceProfile,
  CustomerInvoiceProfileListParams,
  CustomerInvoiceProfileListResponse,
  UpdateCustomerInvoiceProfileDto
} from '@/types/CustomerInvoiceProfile.interface';

const detailUrl = (id: number): string =>
  CUSTOMER_INVOICE_PROFILE_DETAIL.replace(':id', String(id));

export const customerInvoiceProfileService = {
  async list(
    params: CustomerInvoiceProfileListParams = {}
  ): Promise<CustomerInvoiceProfileListResponse> {
    const response = await apiClient.get<CustomerInvoiceProfileListResponse>(
      CUSTOMER_INVOICE_PROFILES,
      params
    );
    return response.data;
  },

  async getById(id: number): Promise<CustomerInvoiceProfile> {
    const response = await apiClient.get<CustomerInvoiceProfile>(detailUrl(id));
    return response.data;
  },

  async update(
    id: number,
    dto: UpdateCustomerInvoiceProfileDto
  ): Promise<CustomerInvoiceProfile> {
    const response = await apiClient.patch<CustomerInvoiceProfile>(
      detailUrl(id),
      { ...dto }
    );
    return response.data;
  },

  /** Soft delete. Fails with a Turkish 400 message while receivables are open. */
  async delete(id: number): Promise<void> {
    await apiClient.delete(detailUrl(id));
  }
};
